<div>
  @if (loading) {
    <div
      class="write-loader absolute left-0 top-0 flex h-full w-full flex-wrap content-center justify-center">
      <mat-spinner diameter="20"></mat-spinner>
    </div>
  }

  <div class="inline" [ngStyle]="{ color: loading ? 'transparent' : '' }">
    {{ text }}
  </div>
</div>
